import { UniversitySearchQueryParams } from '../models/university-search.models';

export const generateLink = (
	baseurl: string,
	queryParams: UniversitySearchQueryParams,
) => {
	const options = [];
	for (const param in queryParams) {
		const key = param as keyof UniversitySearchQueryParams;

		if (queryParams[key]) {
			options.push(`${key}=${queryParams[key]}`);
		}
	}

	return options.length > 0 ? `${baseurl}?${options.join('&')}` : baseurl;
};
